import { useFormSchema } from "src/api/hooks/useFormSchema";

export const TextAreaWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;

  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`textarea-container container`}>
      <textarea
        name={label}
        id={`${id}-textarea`}
        className={`input-textarea`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
      />
    </div>
  );
};
